import React from "react";
import Icon from "../../assets/images/profile.svg";
import PingUser from "./PingUser";
import moment from "moment/moment";
export const Profile = ({props}) => {

  return (
    <div className="profile-div d-flex">
      <div className="d-flex" style={{ flexGrow: 1 }}>
        {" "}
        <img src={Icon} width="23px" />
        <div>
          <h6>{props.name}</h6>
          <small>
              {`${moment(props.updatedAt).format("MMM Do, YYYY.")}  `}. {` ${moment(props.updatedAt).format("HH:MM:SS")}  `}
          </small>
        </div>
      </div>
      <div className="d-flex">
        <button className="pend-btn" style={{color: props.status_cls}}>{`${props.status}`}</button>
        <div>
          <p className="offset-6">{props.amount}+</p>

          {/*<PingUser />*/}
        </div>
      </div>
    </div>
  );
};
